export const setProperty2Element = (el: HTMLElement | undefined, property: string, value: string | null) => {
  const target = el ?? document.documentElement
  target?.style.setProperty(property, value)
}

export const removeProperty2Element = (el: HTMLElement | undefined, property: string) => {
  const target = el ?? document.documentElement
  target?.style.removeProperty(property)
}

export const getElementOffsetTop = (el: HTMLElement | null, recursive?: boolean): number => {
  if (el && recursive) {
    return el.offsetTop + getElementOffsetTop(el.parentElement, recursive)
  }
  return el?.offsetTop ?? 0
}
